/* ── Indian Calendar 365 Days Festival & Event Templates ── */

export const greetingTemplates = [
  // ── 0..9: Core & General (Preserves backward compatibility & tests) ──
  {
    id: 0,
    label: 'General Greeting',
    category: 'Business & Care',
    text: 'Dear {name},\n\nGreetings from our shop! We hope you are doing well. We are always at your service with the finest quality and support. 🙏'
  },
  {
    id: 1,
    label: 'Festival Offer',
    category: 'Business & Care',
    text: '🎉 *Happy Festival Season!* 🎉\n\nDear {name},\n\nWishing you joy and prosperity! ✨\nWe have _exciting offers_ waiting for you.\n\nVisit us today! 🙏'
  },
  {
    id: 2,
    label: 'Birthday Wish',
    category: 'Personal & Care',
    text: '🎂 *Happy Birthday, {name}!* 🎈\n\nWishing you a wonderful year ahead filled with happiness, health, and success! ✨\n\nHere\'s a _special birthday treat & exclusive discount_ just for you on your special day! 🎁\n\nWarm wishes ❤️'
  },
  {
    id: 3,
    label: 'Anniversary Wish',
    category: 'Personal & Care',
    text: '💍 *Happy Anniversary, {name}!* ❤️\n\nCelebrate this special milestone of togetherness with joy. Wishing you many more wonderful years ahead!\n\nEnjoy our _exclusive anniversary offers_ on your visit today! 🎉'
  },
  {
    id: 4,
    label: 'New Arrival',
    category: 'Business & Care',
    text: '🌟 *New Arrivals Alert!* 🌟\n\nDear {name},\n\nExciting news! _Brand new products & fresh stock_ have just arrived at our store. 📦\n\nCome check them out before they\'re gone! 🛒'
  },
  {
    id: 5,
    label: 'Thank You',
    category: 'Business & Care',
    text: '🙏 *Thank You, {name}!*\n\nWe truly appreciate your business and trust in us. ❤️\n\nYou are a valued customer and we look forward to serving you again! ✨'
  },
  {
    id: 6,
    label: 'Payment Reminder',
    category: 'Business & Care',
    text: '📌 *Friendly Reminder*\n\nDear {name},\n\nThis is a gentle reminder regarding your _pending payment_.\n\nPlease settle at your earliest convenience. Thank you for your cooperation! 🙏'
  },
  {
    id: 7,
    label: 'Diwali',
    category: 'November (Festive Peak)',
    text: '🪔 *Happy Diwali & Shubh Deepawali, {name}!* 🎆\n\nMay this festival of lights bring joy, prosperity, good health, and infinite happiness to you and your family! ✨\n\n_Special festive offers & discounts_ await you at our store! 🎁'
  },
  {
    id: 8,
    label: 'New Year',
    category: 'January (New Beginnings)',
    text: '🎉 *Happy New Year, {name}!* 🎆\n\nWishing you a year filled with grand success, good health, and happiness! ✨\n\nThank you for your support. _Exciting New Year offers_ coming your way! 🎁'
  },
  {
    id: 9,
    label: 'Custom',
    category: 'Custom',
    text: ''
  },

  // ── More Business & Everyday Templates ──
  {
    id: 10,
    label: 'Weekend Flash Sale',
    category: 'Business & Care',
    text: '🛍️ *Weekend Special Dhamaka!* 🛍️\n\nDear {name},\n\nEnjoy _exclusive discounts & bundle offers_ this Saturday & Sunday across our store! 🛒\n\nHurry, offers valid till stock lasts! 💥'
  },
  {
    id: 11,
    label: 'Clearance & Season End Sale',
    category: 'Business & Care',
    text: '🏷️ *Mega Clearance Sale!* 🏷️\n\nDear {name},\n\nUnbelievable discounts on select items! Grab your favorites at _lowest prices of the season_. 🏃‍♂️💨\n\nVisit us today and save big! 🛒'
  },
  {
    id: 12,
    label: 'Feedback & Review Request',
    category: 'Business & Care',
    text: '⭐ *We Value Your Feedback!* ⭐\n\nDear {name},\n\nThank you for shopping with us! How was your recent experience? Your feedback helps us serve you even better. 🙏\n\nPlease let us know your thoughts or rate our service. Warm regards! ❤️'
  },
  {
    id: 13,
    label: 'VIP Customer Exclusive',
    category: 'Business & Care',
    text: '👑 *VIP Customer Exclusive Privilege!* 👑\n\nDear {name},\n\nAs one of our most valued patrons, you have unlocked an _exclusive VIP discount_. 🌟\n\nShow this message in-store to claim your special benefits! 🎁'
  },

  // ── January Festivals & Events ──
  {
    id: 14,
    label: 'Guru Gobind Singh Jayanti',
    category: 'January (New Beginnings)',
    text: '🙏 *Happy Guru Gobind Singh Jayanti, {name}!* ⚔️✨\n\nMay the teachings of courage, compassion, and truth guide your life with strength and wisdom.\n\n"Deh Shiva Bar Mohe Ehai, Shubh Karman Te Kabhoon Na Taron." Lakh Lakh Vadhaiyan! 🌸'
  },
  {
    id: 15,
    label: 'National Youth Day (Vivekananda Jayanti)',
    category: 'January (New Beginnings)',
    text: '🇮🇳 *Happy National Youth Day, {name}!* 🌅\n\n"Arise, awake, and stop not till the goal is reached." — Swami Vivekananda.\n\nWishing you unlimited energy, vision, and triumph in all your endeavors! 🚀'
  },
  {
    id: 16,
    label: 'Lohri',
    category: 'January (New Beginnings)',
    text: '🔥 *Happy Lohri, {name}!* 🌾\n\nMay the holy bonfire burn away all hardships and usher in warmth, prosperity, and sweet memories! ✨\n\nLohri diyan lakh lakh vadhaiyan! 🥜🍿'
  },
  {
    id: 17,
    label: 'Makar Sankranti / Uttarayan',
    category: 'January (New Beginnings)',
    text: '🪁 *Happy Makar Sankranti & Uttarayan, {name}!* ☀️\n\n"Tilgul ghya, god god bola!" 🍯\nMay your life soar high like kites in the open sky, blessed with sweetness, health, and prosperity! 🌾'
  },
  {
    id: 18,
    label: 'Pongal / Thai Pongal',
    category: 'January (New Beginnings)',
    text: '🌾 *Iniya Pongal Nalvazhthukkal, {name}!* 🍯\n\n"Pongalo Pongal!" May this auspicious harvest festival overflow your home with bountiful wealth, health, and peace! ☀️🪴'
  },
  {
    id: 19,
    label: 'Magh Bihu / Bhogali Bihu',
    category: 'January (New Beginnings)',
    text: '🔥 *Happy Magh Bihu, {name}!* 🌾\n\nWishing you joyful Meji bonfires, delicious pitha, and a blessed harvest season filled with abundance and community warmth! 🌸'
  },
  {
    id: 20,
    label: 'Indian Army Day (15 January)',
    category: 'January (New Beginnings)',
    text: '🇮🇳 *Salute on Indian Army Day!* 🎖️\n\nDear {name},\n\nWe salute the valor, dedication, and supreme sacrifice of our brave soldiers guarding our motherland 24/7. Jai Hind! 🇮🇳'
  },
  {
    id: 21,
    label: 'Subhas Chandra Bose Jayanti (Parakram Diwas)',
    category: 'January (New Beginnings)',
    text: '🇮🇳 *Salute on Parakram Diwas, {name}!* ⚔️\n\nRemembering Netaji Subhas Chandra Bose whose fiery courage and patriotism inspire our nation. "Give me blood, and I will give you freedom!" Jai Hind! 🇮🇳'
  },
  {
    id: 22,
    label: 'Republic Day (26 January)',
    category: 'January (New Beginnings)',
    text: '🇮🇳 *Happy Republic Day, {name}!* 🇮🇳\n\nLet us honor the Constitution, the unity in diversity, and the proud heritage of our great nation India.\n\nCelebrate with our _special Republic Day festive offers_! Vande Mataram! Jai Hind! 🌟'
  },

  // ── February Festivals & Events ──
  {
    id: 23,
    label: 'Vasant Panchami / Saraswati Puja',
    category: 'February (Spring Celebrations)',
    text: '🌼 *Happy Vasant Panchami & Saraswati Puja, {name}!* 🪕✨\n\nMay Goddess Saraswati illuminate your life with knowledge, wisdom, creativity, and flourishing prosperity! 📚🟡'
  },
  {
    id: 24,
    label: 'Guru Ravidas Jayanti',
    category: 'February (Spring Celebrations)',
    text: '🙏 *Happy Guru Ravidas Jayanti, {name}!* 🌸\n\n"Man changa to kathoti mein Ganga." May the noble teachings of universal brotherhood, humility, and equality inspire us always! ✨'
  },
  {
    id: 25,
    label: 'Chhatrapati Shivaji Maharaj Jayanti (19 Feb)',
    category: 'February (Spring Celebrations)',
    text: '🚩 *Shiv Jayanti Chya Hardik Shubhechha, {name}!* ⚔️\n\nRemembering the founder of Hindavi Swarajya, the visionary leader whose valor and justice inspire generations. Jai Bhavani! Jai Shivaji! 🚩'
  },
  {
    id: 26,
    label: 'Maha Shivratri',
    category: 'February (Spring Celebrations)',
    text: '🔱 *Happy Maha Shivratri, {name}!* 🕉️\n\nMay Lord Shiva and Maa Parvati shower divine blessings of peace, strength, good health, and immense prosperity on you and your family.\n\nHar Har Mahadev! Om Namah Shivaya! 🌿🌸'
  },
  {
    id: 27,
    label: 'Valentine’s Day / Customer Appreciation',
    category: 'February (Spring Celebrations)',
    text: '💖 *Happy Valentine’s Season, {name}!* 🌹\n\nWe love serving valued customers like you! Enjoy our _special love & appreciation discounts_ this week. Celebrate sweet moments! ❤️🎁'
  },
  {
    id: 28,
    label: 'National Science Day (28 February)',
    category: 'February (Spring Celebrations)',
    text: '🔬 *Happy National Science Day, {name}!* 💡\n\nSaluting Sir C.V. Raman and the spirit of curiosity, inquiry, and scientific innovation propelling India forward! 🚀'
  },

  // ── March Festivals & Events ──
  {
    id: 29,
    label: 'International Women’s Day (8 March)',
    category: 'March (Colors & Renewal)',
    text: '🌸 *Happy International Women’s Day, {name}!* 👑💜\n\nSaluting the power, grace, and leadership of women who inspire and lead our families and society.\n\nEnjoy our _special Women’s Day privilege discounts_ today! ✨'
  },
  {
    id: 30,
    label: 'Holika Dahan',
    category: 'March (Colors & Renewal)',
    text: '🔥 *Shubh Holika Dahan, {name}!* 🪵✨\n\nMay the sacred fire of Holika Dahan burn away all negativity, illnesses, and sorrows, ushering in purity, joy, and peace! 🪔'
  },
  {
    id: 31,
    label: 'Holi / Dhulandi',
    category: 'March (Colors & Renewal)',
    text: '🎨 *Happy Holi, {name}!* 🌈💦\n\nWishing you and your loved ones a vibrant festival filled with the colors of joy, love, laughter, and flourishing success! 🍬\n\n_Special festive Holi offers_ waiting for you at our shop! 🎁'
  },
  {
    id: 32,
    label: 'Rang Panchami',
    category: 'March (Colors & Renewal)',
    text: '✨ *Happy Rang Panchami, {name}!* 🎨🌸\n\nMay the auspicious celestial colors of Rang Panchami bring pure bliss, harmony, and prosperity to your household! 🌟'
  },
  {
    id: 33,
    label: 'Bihar Diwas (22 March)',
    category: 'March (Colors & Renewal)',
    text: '🌾 *Shubh Bihar Diwas, {name}!* 🌸\n\nCelebrating the glorious history, intellectual heritage, and vibrant culture of Bihar. Wishing peace and progress to all! ✨'
  },
  {
    id: 34,
    label: 'Shaheed Diwas (23 March)',
    category: 'March (Colors & Renewal)',
    text: '🇮🇳 *Tribute on Shaheed Diwas, {name}!* 🇮🇳\n\nSaluting the supreme sacrifice of Bhagat Singh, Rajguru, and Sukhdev for our motherland. Their spirit lives in our hearts forever. Inquilab Zindabad! 🇮🇳'
  },

  // ── April Festivals & Events ──
  {
    id: 35,
    label: 'Chaitra Navratri',
    category: 'April (Harvest & New Year)',
    text: '🌸 *Happy Chaitra Navratri, {name}!* 🚩🪔\n\nMay Maa Durga shower her nine divine blessings of health, wealth, courage, and happiness upon you and your family! Jai Mata Di! 🙏'
  },
  {
    id: 36,
    label: 'Gudi Padwa (Maharashtra New Year)',
    category: 'April (Harvest & New Year)',
    text: '🚩 *Gudi Padwyachya Hardik Shubhechha, {name}!* 🌾🍯\n\nMay this auspicious New Year bring new beginnings, robust health, and grand prosperity into your home!\n\n_Special Gudi Padwa Muhurat discounts_ on our products! ✨'
  },
  {
    id: 37,
    label: 'Ugadi (Telugu & Kannada New Year)',
    category: 'April (Harvest & New Year)',
    text: '🌿 *Ugadi Subhakankshalu, {name}!* 🥭🌸\n\nMay the sweet-sour flavors of Ugadi Pachadi fill your year ahead with balanced happiness, peace, and abundance! ✨'
  },
  {
    id: 38,
    label: 'Cheti Chand (Sindhi New Year)',
    category: 'April (Harvest & New Year)',
    text: '🐟 *Cheti Chand Jyun Lakh Lakh Vadhayun, {name}!* 🌊🚩\n\nMay Lord Jhulelal bless you with boundless success, joy, peace, and good health. Aayo Lal Sabhaiyo Chhavo Jhulelal! 🙏'
  },
  {
    id: 39,
    label: 'Ram Navami',
    category: 'April (Harvest & New Year)',
    text: '🏹 *Happy Shri Ram Navami, {name}!* 🚩🌸\n\nMay the virtues, righteousness, and divine blessings of Maryada Purushottam Lord Shri Ram illuminate your life always. Jai Shri Ram! 🙏✨'
  },
  {
    id: 40,
    label: 'Mahavir Jayanti',
    category: 'April (Harvest & New Year)',
    text: '🕊️ *Happy Mahavir Jayanti, {name}!* 🌸\n\n"Ahimsa Paramo Dharma." May the divine teachings of Lord Mahavira inspire kindness, truth, and peace in your heart. Jai Jinendra! 🙏'
  },
  {
    id: 41,
    label: 'Good Friday & Easter',
    category: 'April (Harvest & New Year)',
    text: '✝️ *Blessed Good Friday & Happy Easter, {name}!* 🕊️🥚\n\nMay the love, grace, peace, and hope of Easter bring joyful blessings to you and your loved ones! 🌸'
  },
  {
    id: 42,
    label: 'Baisakhi / Vaisakhi',
    category: 'April (Harvest & New Year)',
    text: '🌾 *Happy Baisakhi, {name}!* 🥁✨\n\nMay the golden harvest fill your home and heart with joy, prosperity, and celebratory bhangra beats! Baisakhi diyan lakh lakh vadhaiyan! 🌸'
  },
  {
    id: 43,
    label: 'Puthandu (Tamil New Year)',
    category: 'April (Harvest & New Year)',
    text: '🥭 *Iniya Puthandu Vazhthukkal, {name}!* 🌸✨\n\nWishing you a prosperous, peaceful, and joyful Tamil New Year filled with sweet moments and flourishing opportunities! 🪴'
  },
  {
    id: 44,
    label: 'Vishu (Kerala New Year)',
    category: 'April (Harvest & New Year)',
    text: '🌼 *Happy Vishu, {name}!* 🪙✨\n\nMay the auspicious golden Vishu Kani bring wealth, good fortune, and joyful abundance to you and your family throughout the year! 🌸'
  },
  {
    id: 45,
    label: 'Pohela Boishakh (Bengali New Year)',
    category: 'April (Harvest & New Year)',
    text: '🌾 *Shubho Noboborsho, {name}!* 🌸🍬\n\nMay the opening of Haal Khata and the arrival of Noboborsho bring sweet success, health, and joy to your family! ✨'
  },
  {
    id: 46,
    label: 'Bohag Bihu / Rongali Bihu',
    category: 'April (Harvest & New Year)',
    text: '🌸 *Happy Rongali Bihu, {name}!* 🌾🥁\n\nMay this vibrant festival of nature and harvest bring happiness, prosperity, and musical joy to your household! ✨'
  },
  {
    id: 47,
    label: 'Pana Sankranti (Odisha New Year)',
    category: 'April (Harvest & New Year)',
    text: '🪴 *Shubha Pana Sankranti & Maha Bishuba Sankranti, {name}!* 🌸\n\nWishing you coolness, sweetness, good health, and peace on this sacred Odia New Year! 🙏'
  },
  {
    id: 48,
    label: 'Dr. B.R. Ambedkar Jayanti (14 April)',
    category: 'April (Harvest & New Year)',
    text: '📘 *Babasaheb Ambedkar Jayanti Chya Shubhechha, {name}!* 🇮🇳\n\nTribute to the chief architect of our Indian Constitution and champion of justice, education, and equality. Jai Bhim! 🌸'
  },
  {
    id: 49,
    label: 'Hanuman Jayanti',
    category: 'April (Harvest & New Year)',
    text: '🚩 *Happy Hanuman Jayanti, {name}!* 🐒🔱\n\nMay Sankat Mochan Lord Hanuman bless you with immense courage, vitality, intellect, and protection from all obstacles. Jai Bajrangbali! 🙏'
  },
  {
    id: 50,
    label: 'Eid al-Fitr (Ramzan Eid)',
    category: 'April (Harvest & New Year)',
    text: '🌙 *Eid Mubarak, {name}!* ✨🍬\n\nMay the divine blessings of Allah bring peace, harmony, prosperity, and delightful happiness to you and your family! Eid Mubarak! 🤲'
  },
  {
    id: 51,
    label: 'World Earth Day (22 April)',
    category: 'April (Harvest & New Year)',
    text: '🌍 *Happy Earth Day, {name}!* 🌱\n\nLet us nurture and protect our Mother Earth with conscious, eco-friendly choices. Green today, greener tomorrow! 🌿'
  },

  // ── May Festivals & Events ──
  {
    id: 52,
    label: 'Maharashtra Din / Gujarat Din / Labour Day (1 May)',
    category: 'May (Summer & Devotion)',
    text: '🚩 *Maharashtra Din & Kamgar Diwas Chya Shubhechha, {name}!* 🇮🇳\n\nSaluting the hard work, perseverance, and dedication of every worker and celebrating Maharashtra & Gujarat foundation day! Jai Hind, Jai Maharashtra! 🚩'
  },
  {
    id: 53,
    label: 'Akshaya Tritiya',
    category: 'May (Summer & Devotion)',
    text: '🪙 *Happy Akshaya Tritiya, {name}!* 🪔✨\n\nMay this auspicious day of everlasting wealth bring boundless prosperity, good fortune, and success into your home!\n\n_Special Akshaya Tritiya Muhurat offers_ active in our store! 🎁'
  },
  {
    id: 54,
    label: 'Rabindranath Tagore Jayanti',
    category: 'May (Summer & Devotion)',
    text: '✍️ *Tribute to Gurudev Rabindranath Tagore, {name}!* 🌸\n\nRemembering our Nobel laureate whose poetry, philosophy, and music continue to illuminate our minds and hearts! 📖'
  },
  {
    id: 55,
    label: 'Buddha Purnima / Vesak',
    category: 'May (Summer & Devotion)',
    text: '🪷 *Happy Buddha Purnima, {name}!* 🕊️\n\nMay Lord Buddha illuminate your mind with tranquility, compassion, non-violence, and righteous wisdom. Peace and joy to all! 🙏'
  },
  {
    id: 56,
    label: 'Mother’s Day',
    category: 'May (Summer & Devotion)',
    text: '❤️ *Happy Mother’s Day, {name}!* 💐\n\nHonoring all incredible mothers whose unconditional love, sacrifices, and guidance make our lives truly blessed! 🌸'
  },

  // ── June Festivals & Events ──
  {
    id: 57,
    label: 'World Environment Day (5 June)',
    category: 'June (Monsoon & Wellness)',
    text: '🌿 *Happy World Environment Day, {name}!* 🌳\n\nLet\'s join hands to protect nature, plant trees, and preserve our Earth for future generations! 🍃'
  },
  {
    id: 58,
    label: 'Father’s Day',
    category: 'June (Monsoon & Wellness)',
    text: '👔 *Happy Father’s Day, {name}!* 🌟\n\nCelebrating our pillars of strength, support, and selfless guidance. Thank you for everything! ❤️'
  },
  {
    id: 59,
    label: 'International Yoga Day (21 June)',
    category: 'June (Monsoon & Wellness)',
    text: '🧘 *Happy International Yoga Day, {name}!* 🕉️\n\n"Yoga is the journey of the self, through the self, to the self." Wishing you health, mental peace, and lifelong wellness! 🌿'
  },
  {
    id: 60,
    label: 'Rath Yatra (Puri Jagannath)',
    category: 'June (Monsoon & Wellness)',
    text: '🚩 *Happy Jagannath Rath Yatra, {name}!* 🛞🌸\n\nMay Lord Jagannath, Balabhadra, and Devi Subhadra shower their divine grace, health, and fortune upon your family. Jai Jagannath! 🙏'
  },
  {
    id: 61,
    label: 'Bakrid / Eid al-Adha',
    category: 'June (Monsoon & Wellness)',
    text: '🐑 *Eid-ul-Adha Mubarak, {name}!* 🌙✨\n\nMay this blessed festival of sacrifice, faith, and charity bring peace, prosperity, and joy to your life! 🤲'
  },
  {
    id: 62,
    label: 'Sant Kabir Das Jayanti',
    category: 'June (Monsoon & Wellness)',
    text: '🙏 *Happy Sant Kabir Jayanti, {name}!* 🌸\n\n"Bura jo dekhan main chala, bura na milya koy." May the timeless wisdom and simplicity of Sant Kabir inspire our deeds! ✨'
  },

  // ── July Festivals & Events ──
  {
    id: 63,
    label: 'National Doctors’ Day (1 July)',
    category: 'July (Gratitude & Devotion)',
    text: '🩺 *Happy National Doctors’ Day, {name}!* 🤍\n\nHeartfelt gratitude to all doctors and healthcare heroes dedicated to saving lives and serving humanity selflessly! 🙏'
  },
  {
    id: 64,
    label: 'CA Day & GST Day (1 July)',
    category: 'July (Gratitude & Devotion)',
    text: '📊 *Happy CA Day & GST Day, {name}!* 📈\n\nCelebrating the financial architects and tax professionals who power the growth, integrity, and trust of our Indian economy! 🇮🇳'
  },
  {
    id: 65,
    label: 'Ashadhi Ekadashi (Pandharpur Wari)',
    category: 'July (Gratitude & Devotion)',
    text: '🚩 *Ashadhi Ekadashi Chya Mangalmay Shubhechha, {name}!* 🪕🙏\n\n"Majhe Maher Pandhari, Ahe Bhivarechya Tiri." May Mauli and Lord Vitthal shower peace, devotion, and good health on your family! Vitthal Vitthal! 🌸'
  },
  {
    id: 66,
    label: 'Guru Purnima',
    category: 'July (Gratitude & Devotion)',
    text: '🙏 *Happy Guru Purnima, {name}!* 🌸🪔\n\n"Gurur Brahma Gurur Vishnu Gurur Devo Maheshwara." Heartfelt reverence to all teachers, mentors, and guides who illuminate our path! 🌟'
  },
  {
    id: 67,
    label: 'Muharram / Ashura',
    category: 'July (Gratitude & Devotion)',
    text: '🕊️ *Muharram Observance, {name}!* 🤲\n\nMay the spirit of truth, justice, righteousness, and patience inspire peace and compassion across all hearts. ✨'
  },
  {
    id: 68,
    label: 'Kargil Vijay Diwas (26 July)',
    category: 'July (Gratitude & Devotion)',
    text: '🇮🇳 *Salute on Kargil Vijay Diwas, {name}!* 🎖️\n\nA proud salute to the extraordinary valor and sacrifice of the Indian Armed Forces who defended our nation in Kargil. Jai Hind! Vande Mataram! 🇮🇳'
  },

  // ── August Festivals & Events ──
  {
    id: 69,
    label: 'Friendship Day',
    category: 'August (Bonds & Freedom)',
    text: '🤝 *Happy Friendship Day, {name}!* 🌟\n\nTo a cherished relationship built on trust and goodwill! Thank you for being a part of our store\'s journey. Wishing you great times ahead! 🎉'
  },
  {
    id: 70,
    label: 'National Handloom Day (7 August)',
    category: 'August (Bonds & Freedom)',
    text: '🧵 *Happy National Handloom Day, {name}!* 🇮🇳\n\nCelebrating India\'s rich weaving heritage, artisanal mastery, and sustainable traditions. Support vocal for local! 🪡'
  },
  {
    id: 71,
    label: 'Hariyali Teej / Hartalika Teej',
    category: 'August (Bonds & Freedom)',
    text: '🌿 *Happy Hariyali & Hartalika Teej, {name}!* 🌺🪔\n\nMay Lord Shiva and Maa Parvati bless you with marital harmony, joyful celebrations, and prosperous well-being! 🌸'
  },
  {
    id: 72,
    label: 'Independence Day (15 August)',
    category: 'August (Bonds & Freedom)',
    text: '🇮🇳 *Happy Independence Day, {name}!* 🇮🇳\n\nCelebrating the freedom, courage, and unity of our beloved nation India!\n\nCelebrate with our _Independence Day Mega Sale & special discounts_! Vande Mataram! Jai Hind! 🌟'
  },
  {
    id: 73,
    label: 'Raksha Bandhan',
    category: 'August (Bonds & Freedom)',
    text: '🧵 *Happy Raksha Bandhan, {name}!* 🌸❤️\n\nCelebrating the sacred bond of protection, unconditional love, and laughter between siblings!\n\n_Special gift ideas & festive discounts_ waiting for you at our store! 🎁'
  },
  {
    id: 74,
    label: 'Krishna Janmashtami',
    category: 'August (Bonds & Freedom)',
    text: '🦚 *Happy Krishna Janmashtami, {name}!* 🪈✨\n\nMay Lord Krishna bless your life with joy, peace, love, and divine fortune! Radhe Krishna! Jai Shri Krishna! 🍯'
  },
  {
    id: 75,
    label: 'Dahi Handi / Govinda',
    category: 'August (Bonds & Freedom)',
    text: '🏺 *Govinda Ala Re Ala! Happy Dahi Handi, {name}!* 🚩🎉\n\nMay the enthusiastic energy of teamwork, courage, and celebration bring high success and joy to your life! 🎈'
  },
  {
    id: 76,
    label: 'Parsi New Year (Navroz)',
    category: 'August (Bonds & Freedom)',
    text: '🌿 *Navroz Mubarak, {name}!* 🌸✨\n\nWishing you a joyful New Year filled with smiles, robust health, peace, and abundance! ✨'
  },
  {
    id: 77,
    label: 'Onam / Thiru Onam',
    category: 'August (Bonds & Freedom)',
    text: '🌼 *Happy Onam, {name}!* ⛵🍯\n\nMay the spirit of King Mahabali fill your home with golden prosperity, delicious Onasadya, and radiant Pookkalam flowers! Onashamsakal! 🌸'
  },
  {
    id: 78,
    label: 'National Sports Day (29 August)',
    category: 'August (Bonds & Freedom)',
    text: '🏆 *Happy National Sports Day, {name}!* 🏑\n\nRemembering hockey legend Major Dhyan Chand! Stay active, play with spirit, and embrace physical fitness! ⚽'
  },

  // ── September Festivals & Events ──
  {
    id: 79,
    label: 'Ganesh Chaturthi',
    category: 'September (Ganesh & Craft)',
    text: '🐘 *Ganpati Bappa Morya! Happy Ganesh Chaturthi, {name}!* 🌺🪔\n\nMay Vighnaharta Lord Ganesha remove all obstacles and bless your home and business with Riddhi, Siddhi, and prosperity!\n\n_Special Ganesh Utsav offers_ available today! 🍬'
  },
  {
    id: 80,
    label: 'Gauri Pujan / Mahalaxmi Pujan',
    category: 'September (Ganesh & Craft)',
    text: '🌸 *Shubh Gauri Avahan & Mahalaxmi Pujan, {name}!* 🪔✨\n\nMay Goddess Gauri and Maa Mahalaxmi reside in your home, bestowing endless wealth, peace, and culinary blessings! 🌾'
  },
  {
    id: 81,
    label: 'Teachers’ Day (5 September)',
    category: 'September (Ganesh & Craft)',
    text: '📚 *Happy Teachers’ Day, {name}!* 🍎\n\nSaluting our teachers and mentors whose guidance shapes character, wisdom, and the future of India! 🙏'
  },
  {
    id: 82,
    label: 'Hindi Diwas (14 September)',
    category: 'September (Ganesh & Craft)',
    text: '🇮🇳 *Hindi Diwas Ki Hardik Shubhkamnayein, {name}!* ✍️\n\nCelebrating the rich beauty, expressiveness, and timeless literature of our official language! 🌸'
  },
  {
    id: 83,
    label: 'Engineers’ Day (15 September)',
    category: 'September (Ganesh & Craft)',
    text: '⚙️ *Happy Engineers’ Day, {name}!* 📐💡\n\nSaluting the visionary genius Sir M. Visvesvaraya and all engineers building progressive infrastructure and technology! 🚀'
  },
  {
    id: 84,
    label: 'Vishwakarma Puja / Jayanti (17 September)',
    category: 'September (Ganesh & Craft)',
    text: '🔨 *Happy Vishwakarma Puja, {name}!* ⚙️✨\n\nMay Lord Vishwakarma, the divine architect, bless your work, tools, machinery, and trade with safety, precision, and immense prosperity! 🙏'
  },
  {
    id: 85,
    label: 'Anant Chaturdashi (Ganesh Visarjan)',
    category: 'September (Ganesh & Craft)',
    text: '🌺 *Anant Chaturdashi Chya Hardik Shubhechha, {name}!* 🚩\n\n"Ganpati Bappa Morya, Pudhchya Varshi Lavkar Ya!" Bidding adieu to Bappa with prayers for your family\'s lasting peace and prosperity! 🌸'
  },
  {
    id: 86,
    label: 'Eid-e-Milad / Milad-un-Nabi',
    category: 'September (Ganesh & Craft)',
    text: '🌙 *Eid Milad-un-Nabi Mubarak, {name}!* 🕊️✨\n\nMay the teachings of peace, mercy, and brotherhood of Prophet Muhammad (PBUH) bring tranquility to your home and heart! 🤲'
  },
  {
    id: 87,
    label: 'World Tourism Day (27 September)',
    category: 'September (Ganesh & Craft)',
    text: '✈️ *Happy World Tourism Day, {name}!* 🌏🎒\n\nDiscover the majestic diversity, landscapes, and culture of Incredible India and beyond! 🌟'
  },

  // ── October Festivals & Events ──
  {
    id: 88,
    label: 'Gandhi Jayanti (2 October)',
    category: 'October (Navratri & Victory)',
    text: '🕊️ *Happy Gandhi Jayanti & Swachhata Diwas, {name}!* 🇮🇳\n\n"Be the change that you wish to see in the world." Remembering Mahatma Gandhi\'s timeless path of truth and non-violence. Jai Hind! 🌸'
  },
  {
    id: 89,
    label: 'Lal Bahadur Shastri Jayanti (2 October)',
    category: 'October (Navratri & Victory)',
    text: '🌾 *Tribute to Lal Bahadur Shastri Ji, {name}!* 🇮🇳\n\nRemembering our inspiring former Prime Minister who championed the spirit of "Jai Jawan! Jai Kisan!" 🇮🇳'
  },
  {
    id: 90,
    label: 'Indian Air Force Day (8 October)',
    category: 'October (Navratri & Victory)',
    text: '✈️ *Salute on Indian Air Force Day, {name}!* 🇮🇳\n\nTouch the sky with glory! Saluting our fearless air warriors guarding Indian airspace with pride and vigilance! 🚀'
  },
  {
    id: 91,
    label: 'Sharad Navratri (Ghatasthapana)',
    category: 'October (Navratri & Victory)',
    text: '🚩 *Shubh Sharad Navratri, {name}!* 🌸🪔\n\nMay Maa Durga\'s nine divine avatars bless your home with strength, good health, and blissful dandiya celebrations! Jai Mata Di! 🙏'
  },
  {
    id: 92,
    label: 'Durga Puja (Maha Ashtami / Navami)',
    category: 'October (Navratri & Victory)',
    text: '🪔 *Shubho Sharadiya & Happy Durga Puja, {name}!* 🥁🌺\n\nMay Maa Durga bestow victory over all hardships, peace, and eternal joy to you and your family! Shubho Pujo! 🌸'
  },
  {
    id: 93,
    label: 'Dussehra / Vijayadashami',
    category: 'October (Navratri & Victory)',
    text: '🏹 *Happy Dussehra & Shubh Vijayadashami, {name}!* 🚩✨\n\nCelebrating the triumph of truth over evil and light over darkness! May your business scale golden heights.\n\n_Special Vijayadashami Muhurat offers_ active now! 🎁'
  },
  {
    id: 94,
    label: 'Karwa Chauth',
    category: 'October (Navratri & Victory)',
    text: '🌙 *Happy Karwa Chauth, {name}!* 🪔❤️\n\nMay the pious moon bless your marital bond with deep love, longevity, and lifelong happiness! 🌸'
  },
  {
    id: 95,
    label: 'Kojagiri Purnima / Sharad Purnima',
    category: 'October (Navratri & Victory)',
    text: '🌕 *Happy Kojagiri Purnima, {name}!* 🥛✨\n\n"Kojagarti — Who is awake?" May Goddess Lakshmi shower nectar, wellness, and fortune upon your family on this moonlit night! 🌸'
  },
  {
    id: 96,
    label: 'Maharishi Valmiki Jayanti',
    category: 'October (Navratri & Victory)',
    text: '📜 *Happy Maharishi Valmiki Jayanti, {name}!* 🌸\n\nSaluting the revered Adi Kavi whose epic Ramayana illuminates the eternal values of truth and devotion! 🙏'
  },
  {
    id: 97,
    label: 'National Unity Day (Sardar Patel Jayanti - 31 Oct)',
    category: 'October (Navratri & Victory)',
    text: '🇮🇳 *National Unity Day / Rashtriya Ekta Diwas, {name}!* 🇮🇳\n\nHonoring the Iron Man of India, Sardar Vallabhbhai Patel, whose visionary resolve unified our motherland into one strong nation! 🌟'
  },

  // ── November Festivals & Events ──
  {
    id: 98,
    label: 'Dhanteras / Dhantrayodashi',
    category: 'November (Festive Peak)',
    text: '🪙 *Happy Dhanteras, {name}!* 🪔✨\n\nMay Lord Dhanvantari and Lord Kuber bless you with good health, immense wealth, and prosperous beginnings!\n\n_Exclusive Dhanteras shopping discounts_ waiting for you today! 🎁'
  },
  {
    id: 99,
    label: 'Narak Chaturdashi / Choti Diwali',
    category: 'November (Festive Peak)',
    text: '🪔 *Happy Choti Diwali & Roop Chaudas, {name}!* 🎆✨\n\nMay the glow of diyas dispel darkness and illuminate your household with joyous anticipation of Deepawali! 🌸'
  },
  {
    id: 100,
    label: 'Govardhan Puja / Annakut',
    category: 'November (Festive Peak)',
    text: '🌾 *Happy Govardhan Puja & Annakut, {name}!* 🏔️🐄\n\nMay Lord Krishna protect and nourish your family with infinite abundance, devotion, and gratitude! 🙏'
  },
  {
    id: 101,
    label: 'Nutan Varshabhinandan (Gujarati New Year)',
    category: 'November (Festive Peak)',
    text: '✨ *Saal Mubarak & Nutan Varshabhinandan, {name}!* 🌸🍯\n\nWishing you a joyful, prosperous, and auspicious New Year filled with profitable business and robust health! 🌾'
  },
  {
    id: 102,
    label: 'Bhai Dooj / Bhau Beej',
    category: 'November (Festive Peak)',
    text: '🌸 *Happy Bhai Dooj / Bhau Beej, {name}!* 🪔❤️\n\nCelebrating the pure bond, blessings, and lifelong protection between sister and brother! 🎁'
  },
  {
    id: 103,
    label: 'Chhath Puja',
    category: 'November (Festive Peak)',
    text: '☀️ *Happy Chhath Puja, {name}!* 🌊🌾\n\nMay Surya Dev and Chhathi Maiya shower divine energy, longevity, and flourishing prosperity upon you and your family! Jai Chhathi Maiya! 🙏'
  },
  {
    id: 104,
    label: 'Tulsi Vivah / Dev Uthani Ekadashi',
    category: 'November (Festive Peak)',
    text: '🪴 *Happy Tulsi Vivah & Dev Uthani Gyaras, {name}!* 🪔✨\n\nWelcoming the auspicious wedding season with sacred prayers, festive joy, and new beginnings! 🌸'
  },
  {
    id: 105,
    label: 'Children’s Day (14 November)',
    category: 'November (Festive Peak)',
    text: '🎈 *Happy Children’s Day, {name}!* 🍭🍦\n\nWishing a bright, joyful, and imaginative future to all children who fill our world with laughter! 🌈'
  },
  {
    id: 106,
    label: 'Guru Nanak Jayanti / Gurpurab',
    category: 'November (Festive Peak)',
    text: '🙏 *Happy Guru Nanak Jayanti / Gurpurab, {name}!* 🌸✨\n\n"Naam Japo, Kirat Karo, Vand Chhako." May the teachings of Guru Nanak Dev Ji guide your life with truth, humility, and peace! Lakh Lakh Vadhaiyan! 🪔'
  },
  {
    id: 107,
    label: 'Constitution Day / Samvidhan Diwas (26 Nov)',
    category: 'November (Festive Peak)',
    text: '📘 *Happy Constitution Day of India, {name}!* 🇮🇳\n\nSaluting our Constitution and recommitting ourselves to justice, liberty, equality, and fraternity! Jai Hind! 🇮🇳'
  },

  // ── December Festivals & Events ──
  {
    id: 108,
    label: 'Indian Navy Day (4 December)',
    category: 'December (Year End & Joy)',
    text: '⚓ *Salute on Indian Navy Day, {name}!* 🇮🇳🌊\n\n"Sham No Varunah" — Saluting our courageous naval warriors who safeguard India\'s waters with supreme vigilance! 🚢'
  },
  {
    id: 109,
    label: 'Armed Forces Flag Day (7 December)',
    category: 'December (Year End & Joy)',
    text: '🎖️ *Armed Forces Flag Day Tribute, {name}!* 🇮🇳\n\nHonoring the martyrs and brave servicemen who defend our nation with selfless devotion! 🇮🇳'
  },
  {
    id: 110,
    label: 'Human Rights Day (10 December)',
    category: 'December (Year End & Joy)',
    text: '🕊️ *Happy Human Rights Day, {name}!* 🤝\n\nStanding for equality, human dignity, and justice for every individual around the world! 🌍'
  },
  {
    id: 111,
    label: 'National Mathematics Day (22 December)',
    category: 'December (Year End & Joy)',
    text: '🔢 *Happy National Mathematics Day, {name}!* 📐\n\nRemembering the legendary Indian mathematical genius Srinivasa Ramanujan on his birth anniversary! 💡'
  },
  {
    id: 112,
    label: 'Kisan Diwas / National Farmers Day (23 Dec)',
    category: 'December (Year End & Joy)',
    text: '🌾 *National Farmers Day / Kisan Diwas, {name}!* 🚜🇮🇳\n\nHeartfelt salutes to our Annadata farmers whose tireless hard work feeds our great nation! Jai Kisan! 🌾'
  },
  {
    id: 113,
    label: 'Christmas Eve (24 December)',
    category: 'December (Year End & Joy)',
    text: '🎄 *Joyful Christmas Eve, {name}!* ❄️🔔\n\nWishing you a cozy, cheerful evening filled with warmth, sweet treats, and holiday joy! 🎁'
  },
  {
    id: 114,
    label: 'Merry Christmas (25 December)',
    category: 'December (Year End & Joy)',
    text: '🎅 *Merry Christmas, {name}!* 🎄✨\n\nMay the peace, joy, and goodwill of Christmas fill your home with happiness!\n\n_Special Christmas discounts & festive offers_ waiting for you at our shop! 🎁'
  },
  {
    id: 115,
    label: 'Good Governance Day (25 December)',
    category: 'December (Year End & Joy)',
    text: '🇮🇳 *Good Governance Day Tribute, {name}!* 🌸\n\nRemembering former Prime Minister Atal Bihari Vajpayee Ji, visionary statesman and orator who inspired our nation! ✍️'
  },
  {
    id: 116,
    label: 'New Year’s Eve (31 December)',
    category: 'December (Year End & Joy)',
    text: '🥂 *Happy New Year’s Eve, {name}!* 🎆🎉\n\nAs we bid farewell to this year, we thank you warmly for your patronage and trust. Here\'s to great success in the upcoming year!\n\n_Year-End Special Countdown Offers_ live now! 🌟'
  }
];

export const TEMPLATE_CATEGORIES = [
  'All',
  'Business & Care',
  'Personal & Care',
  'January (New Beginnings)',
  'February (Spring Celebrations)',
  'March (Colors & Renewal)',
  'April (Harvest & New Year)',
  'May (Summer & Devotion)',
  'June (Monsoon & Wellness)',
  'July (Gratitude & Devotion)',
  'August (Bonds & Freedom)',
  'September (Ganesh & Craft)',
  'October (Navratri & Victory)',
  'November (Festive Peak)',
  'December (Year End & Joy)',
  'Custom'
];
